<template>
    <DnTextarea
        class="base-textarea"
    >
        <template
            v-for="(_, slot) of $slots"
            v-slot:[slot]="scope"
        >
            <slot
                :name="slot"
                v-bind="scope"
            />
        </template>
    </DnTextarea>
</template>

<script setup>
import { DnTextarea } from '@digitalnatives/form-input';
</script>

<style src="./BaseTextarea.less" lang="less"></style>
